import { MessageOut } from "../MessageOut.js";
import type { MessageIOContext } from "../MessageIOContext.js";


export class MessageOutAnalyseGame extends MessageOut {
    public readonly gameID: string;

    constructor(gameID: string) {
        super();
        this.gameID = gameID;
    }

    write(_context: MessageIOContext): Record<string, any> {
        return { game_id: this.gameID };
    }
}
